angular.module("UI8.components").component("shots", {
  template: `<div class="shots page">
      <div class="page__container container">
        <div class="page__hero shots__hero">
          <h1 class="page__title">Shots</h1>
          <div class="page__description">Fresh work from UI8 designers</div>
          <a class="btn shots__post" ng-if="$ctrl.canPost" href="/shots/new">Post a shot</a>
        </div>
        <div class="shots__filters" ng-if="$ctrl.total || $ctrl.tag">
          <button class="filters__btn" ng-class="{active: $ctrl.sort === 'recent'}" ng-click="$ctrl.setSort('recent')">Recent</button>
          <button class="filters__btn" ng-class="{active: $ctrl.sort === 'popular'}" ng-click="$ctrl.setSort('popular')">Popular</button>
        </div>
        <div class="tagrow" ng-if="$ctrl.tags.length">
          <button class="tagrow__chip" ng-class="{active: !$ctrl.tag}" ng-click="$ctrl.setTag(null)">All</button>
          <button class="tagrow__chip" ng-repeat="t in $ctrl.tags track by t" ng-class="{active: $ctrl.tag === t}" ng-click="$ctrl.setTag(t)">{{ t }}</button>
        </div>
        <div class="shots__grid" ng-if="$ctrl.total">
          <shot-card ng-repeat="shot in $ctrl.shots track by shot._id" shot="shot" user="$ctrl.user"></shot-card>
        </div>
        <div class="shots__foot" ng-if="$ctrl.loading">
          <div class="loader loader--small"></div>
        </div>
        <div class="shots__empty" ng-if="!$ctrl.total && !$ctrl.loading">
          <div class="spage__title">{{ $ctrl.tag ? "Nothing tagged " + $ctrl.tag + " yet." : "No shots yet." }}</div>
          <div class="spage__content" ng-if="!$ctrl.tag">Be the first — post work you're proud of.</div>
          <button class="btn btn--stroke" ng-if="$ctrl.tag" ng-click="$ctrl.setTag(null)">Show all shots</button>
          <a class="btn" ng-if="$ctrl.canPost" href="/shots/new">Post a shot</a>
        </div>
      </div>
    </div>`,

  controller: function ($scope, $window, ShotService) {
    var ctrl = this;

    ctrl.$onInit = function () {
      ctrl.shots = ctrl.data.shots || [];
      ctrl.meta = ctrl.data.meta || { page: 1, pages: 1, total: 0 };
      ctrl.total = ctrl.meta.total || 0;
      ctrl.canPost = !!ctrl.data.can_post;
      ctrl.tags = ctrl.data.tags || [];
      ctrl.tag = null;
      ctrl.sort = "recent";
      ctrl.loading = false;

      $window.addEventListener("scroll", onScroll, { passive: true });
      fillViewport();
    };

    ctrl.$onDestroy = function () {
      $window.removeEventListener("scroll", onScroll);
    };

    ctrl.setSort = function (sort) {
      if (ctrl.sort === sort || ctrl.loading) return;
      ctrl.sort = sort;
      ctrl.loading = true;

      ShotService.list({ page: 1, sort: sort, tag: ctrl.tag })
        .then(function (data) {
          ctrl.shots = data.shots;
          ctrl.meta = data.meta;
          ctrl.total = data.meta.total;
        })
        .finally(function () {
          ctrl.loading = false;
          fillViewport();
        });
    };

    ctrl.setTag = function (tag) {
      if (ctrl.tag === tag || ctrl.loading) return;
      ctrl.tag = tag;
      ctrl.loading = true;

      ShotService.list({ page: 1, sort: ctrl.sort, tag: tag })
        .then(function (data) {
          ctrl.shots = data.shots;
          ctrl.meta = data.meta;
          ctrl.total = data.meta.total;
        })
        .finally(function () {
          ctrl.loading = false;
          fillViewport();
        });
    };

    ctrl.more = function () {
      if (ctrl.loading || ctrl.meta.page >= ctrl.meta.pages) return;
      ctrl.loading = true;

      ShotService.list({ page: ctrl.meta.page + 1, sort: ctrl.sort, tag: ctrl.tag })
        .then(function (data) {
          ctrl.shots = ctrl.shots.concat(data.shots);
          ctrl.meta = data.meta;
        })
        .finally(function () {
          ctrl.loading = false;
          fillViewport();
        });
    };

    // Infinite scroll: fetch the next page as the viewport nears the bottom
    function onScroll() {
      var doc = $window.document.documentElement;
      var remaining =
        doc.scrollHeight - $window.pageYOffset - $window.innerHeight;

      if (remaining < 600) {
        $scope.$applyAsync(function () {
          ctrl.more();
        });
      }
    }

    // Tall viewports can swallow the whole first page — keep loading
    // until the page overflows or results run out (favorites.js pattern)
    function fillViewport() {
      setTimeout(function () {
        var doc = $window.document.documentElement;
        if (
          doc.scrollHeight <= $window.innerHeight + 200 &&
          ctrl.meta.page < ctrl.meta.pages &&
          !ctrl.loading
        ) {
          $scope.$applyAsync(function () {
            ctrl.more();
          });
        }
      }, 150);
    }
  },

  bindings: {
    data: "<",
    user: "<",
  },
});
